export const experiences = [
  {
    id: 3,
    company: "Pumex Infotech Pvt ltd",
    companyLink: "https://pumexinfotech.com/",
    position: "Senior Software Engineer",
    duration: "Apr 2025 - Present",
    description: [
      "Explored more technologies like Next JS, Fast API",
      "Working on AI tools like Camel-AI for synthetic data generation",
      "Working on third-party services like Supertoken, Stripe, PostHog, Plaussible.",
      "Working on Google cloud services like Google Cloud Run, Google Compute Engine, Alloy DB",
    ],
  },
  {
    id: 2,
    company: "Pumex Infotech Pvt ltd",
    companyLink: "https://pumexinfotech.com/",
    position: "Software Engineer",
    duration: "Nov 2022 - Mar 2025",
    description: [
      "Designed, developed, and maintained scalable web applications.",
      "Worked with various front-end technologies, including React and Flutter.",
      "Learned and worked with various back-end technologies, such as Django REST framework.",
      "Implemented containerization solutions using Docker.",
      "Learned and implemented event-streaming solutions using Kafka.",
      "Worked closely with designers and back-end developers to ensure seamless integration and functionality.",
    ],
  },
  {
    id: 1,
    company: "CIAL",
    companyLink: "https://www.cial.aero/",
    position: "CRM Executive & Web administration",
    duration: "Sep 2022 - Nov 2022",
    description: [
      "Managed and optimized CRM tools to track and improve customer interactions.",
      "Coordinated with sales and marketing teams to ensure seamless lead tracking and follow-up.",
      "Administered the company's e-commerce website, ensuring uptime, functionality, and regular content updates.",
    ],
  },
];

export const projects = [
  {
    id: 1,
    name: "Safety Violation Detection using AI",
    technologies: [
      "React",
      "Python",
      "Docker",
      "Kafka",
      "OpenCV",
      "FFMPEG",
      "Tailwind cSS",
    ],
    description:
      "An AI platform for real-time safety violation detection in high-risk industries using. ",
    githubLink: "https://github.com/example/project-management",
    liveLink: "https://project-management.example.com",
  },
  {
    id: 2,
    name: "Mangoapeal",
    technologies: ["Django", "Bootstrap", "MySql", "Javascript", "HTML", "CSS"],
    description:
      "An e-commerce web application for selling handcrafted products made from recycled plastic materials, aimed at reducing and reusing plastic waste.",
    githubLink: "https://github.com/example/ecommerce-platform",
  },
  {
    id: 3,
    name: "Money Expense Tracker",
    technologies: [
      "React",
      "Node JS",
      "Mongo DB",
      "Express",
      "CSS",
      "REST API",
    ],
    description:
      "A MERN stack web application for accurate and user-friendly expense tracking.",
    githubLink: "https://github.com/example/ecommerce-platform",
  },
  {
    id: 4,
    name: "Advanced Data Analyzing using AI",
    technologies: ["Flutter", "Flutter flow"],
    description:
      " Built a data analysis tool leveraging LLMs for generating narrative reports based on analytical questions, using Flutter for UI development.",
    githubLink: "https://github.com/example/ecommerce-platform",
  },
];

export const education = [
  {
    id: 1,
    institution: "Mahatma Gandhi University, Kottayam",
    degree: "Master of Computer Application",
    graduationYear: "2022",
    highlights: ["Graduated with SCGPA: 8.3/10.0."],
  },
  {
    id: 2,
    institution: "Mahatma Gandhi University, Kottayam",
    degree: "Bachelor of Computer Application",
    graduationYear: "2020",
    highlights: ["Graduated with SCGPA: 7.3/10.0."],
  },
];
